import { Flexbox } from '@morressier/ts';
import {
  EmptyUserEventContainer,
  EmptyUserEventTitleContainer,
  EmptyUserEventTitle
} from 'components/UserEvents/style';
import SubmissionIcon from './SubmissionIcon';

const EmptyState = () => {
  const text = "YOU HAVEN'T READ ANY RESEARCH YET.";
  return (
    <EmptyUserEventContainer>
      <Flexbox flexDirection="row">
        <SubmissionIcon />
        <EmptyUserEventTitleContainer>
          <EmptyUserEventTitle>{text}</EmptyUserEventTitle>
        </EmptyUserEventTitleContainer>
      </Flexbox>
    </EmptyUserEventContainer>
  );
};

export default EmptyState;
